module.exports = __webpack_public_path__ + "img/Bluemarine-G.af355aee.png";